const Fab = {
    baseStyle: {
        width: "3rem",
        height: "3rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "3px solid",
        borderRadius: "40px",
        _disabled: {
            opacity: 1,
        },
        _focusVisible: {
            boxShadow: "none",
        },
        _hover: {
            boxShadow: "large",
            _disabled: {
                boxShadow: "none",
            },
        },
        _active: {
            boxShadow: "medium",
        },
    },
    sizes: {
        lg: {
            fontSize: "md",
            lineHeight: "base",
        },
        md: {
            fontSize: "sm",
            lineHeight: "short",
            height: "2rem",
            width: "2rem",
        },
    },
    variants: {
        primary: {
            backgroundColor: "semantic.cta.primary",
            borderColor: "semantic.foreground.primary",
            color: "semantic.icon.primary",
            _hover: {
                backgroundColor: "semantic.cta.primaryHover",
                borderColor: "semantic.foreground.primary",
                color: "semantic.icon.primary",
                _disabled: {
                    cursor: "not-allowed",
                    color: "semantic.icon.disabled",
                    borderColor: "semantic.border.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
                _loading: {
                    backgroundColor: "semantic.cta.primaryHover",
                    borderColor: "semantic.foreground.primary",
                },
            },
            _active: {
                border: "none",
                backgroundColor: "semantic.cta.primaryPressed",
                color: "semantic.icon.inverse",
                _disabled: {
                    border: "3px solid",
                    cursor: "not-allowed",
                    color: "semantic.icon.disabled",
                    borderColor: "semantic.border.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
                _loading: {
                    border: "3px solid",
                    backgroundColor: "semantic.cta.primaryHover",
                    borderColor: "semantic.foreground.primary",
                },
            },
            _focusVisible: {
                backgroundColor: "semantic.cta.primaryHover",
                borderColor: "semantic.foreground.primary",
                color: "semantic.icon.primary",
                outlineColor: "semantic.outline.focus ",
                outlineWidth: "3px",
                outlineOffset: "1.5px",
                outlineStyle: "solid",
            },
            _disabled: {
                cursor: "not-allowed",
                color: "semantic.icon.disabled",
                borderColor: "semantic.border.disabled",
                backgroundColor: "semantic.background.disabled",
            },
            _loading: {
                cursor: "not-allowed",
                backgroundColor: "semantic.cta.primaryHover",
                borderColor: "semantic.foreground.primary",
            },
        },
        secondary: {
            border: "none",
            backgroundColor: "semantic.cta.secondary",
            color: "semantic.icon.inverse",
            _hover: {
                border: "none",
                backgroundColor: "semantic.cta.secondaryHover",
                color: "semantic.icon.primary",
                _disabled: {
                    border: "none",
                    cursor: "not-allowed",
                    color: "semantic.icon.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
                _loading: {
                    border: "none",
                    backgroundColor: "semantic.cta.secondaryHover",
                    color: "semantic.icon.primary",
                },
            },
            _active: {
                border: "none",
                backgroundColor: "semantic.cta.secondaryPressed",
                color: "semantic.icon.inverse",
                _disabled: {
                    border: "none",
                    cursor: "not-allowed",
                    color: "semantic.icon.disabled",
                    backgroundColor: "semantic.background.disabled",
                },
                _loading: {
                    border: "none",
                    backgroundColor: "semantic.cta.secondaryHover",
                    color: "semantic.icon.primary",
                },
            },
            _focusVisible: {
                border: "none",
                backgroundColor: "semantic.cta.secondaryHover",
                color: "semantic.icon.primary",
                outlineColor: "semantic.outline.focus ",
                outlineWidth: "3px",
                outlineOffset: "1.5px",
                outlineStyle: "solid",
            },
            _disabled: {
                border: "none",
                cursor: "not-allowed",
                color: "semantic.icon.disabled",
                backgroundColor: "semantic.background.disabled",
            },
            _loading: {
                border: "none",
                cursor: "not-allowed",
                backgroundColor: "semantic.cta.secondaryHover",
                color: "semantic.icon.primary",
            },
        },
    },
    defaultProps: {
        size: "lg",
        variant: "primary",
    },
};
export default Fab;
//# sourceMappingURL=Fab.default.js.map